
































import { createComponent, computed, ref, watch } from "@vue/composition-api";
import { useActions } from "@/shared/useMegaraxClient";
import SearchResult from "./SearchResult.vue";
import { searchResultResource } from "@megarax/client/src/resources/search/SearchResult";

interface Props {
  searchTerm: string;
}

export default createComponent<Props>({
  components: { SearchResult },
  props: {
    searchTerm: { required: true },
  },
  setup(props, ctx) {
    const results = ref<null | any[]>(null);
    const perPage = 10;
    const currentPage = ref(1);
    const resultCount = ref(0);
    var lastRequestIndex = 0;

    const searchResultActions = useActions(searchResultResource);

    async function loadResults() {
      const thisRequestIndex = ++lastRequestIndex;

      const { items, count } = await searchResultActions.search({
        offset: (currentPage.value - 1) * perPage,
        limit: perPage,
        searchTerm: props.searchTerm,
      });

      if (lastRequestIndex > thisRequestIndex) return;

      results.value = items;
      resultCount.value = count;
    }
    watch([currentPage], loadResults, { lazy: true });

    loadResults();

    return { results, loadResults, currentPage, resultCount, perPage };
  },
});
